import { init } from 'cse-chatbot';
import { DecagonInstance } from 'cse-chatbot/dist/types/types';

interface CreateDecagonClientOptions {
    source: string;
    projectId: string;
    env: 'stage' | 'prod';
}

interface InitParams {
    authToken?: string;
    handoffToken?: string;
}

export function createDecagonClient({ env, projectId, source }: CreateDecagonClientOptions) {
    let initPromise: Promise<DecagonInstance> | null = null;

    return {
        get isNotInitialised() {
            return initPromise === null;
        },

        async open() {
            if (!initPromise) return;

            const instance = await initPromise;
            instance.open();
        },

        async hide() {
            if (!initPromise) return;

            const instance = await initPromise;
            instance.close();
            instance.hide();
        },

        async initialise({ authToken, handoffToken }: InitParams): Promise<DecagonInstance> {
            if (initPromise) {
                return initPromise;
            }

            initPromise = (async () => {
                const { decagon } = await init({
                    env,
                    source,
                    projectId,
                    authToken,
                    handoffToken,
                    companyName: 'welltech',
                    extraMetaData: {},
                });

                return decagon;
            })();

            return initPromise;
        },
    };
}
